import { trackInfraUpltTimingTraceUserInteractions } from "@faire/web-api--source/events/infra/timing/uplt";
import { trackInfraLoadAnimationFramesView } from "@faire/web-api--source/events/infra/view/loadAnimationFrames";
import { getGlobalProperty } from "../globals/getGlobalProperty";
import { detectQuietMainThread } from "./detectQuietMainThread";
var DEFAULT_MAX_QUIET_WINDOW_WAIT_TIME = 1000;
var FRAME_LATENCY_THRESHOLD = 20;
var MAX_FRAMES_TO_SEND = 200;
export var trackQuietMainThread = function(pageName, loadType, abortNotifier) {
    return detectQuietMainThread(DEFAULT_MAX_QUIET_WINDOW_WAIT_TIME, FRAME_LATENCY_THRESHOLD, abortNotifier, [
        "CLEAN_UP"
    ]).then(function(result) {
        // Send load time animation frames
        if (!result.frameDurations) {
            return;
        }
        trackInfraLoadAnimationFramesView(result.frameDurations.slice(0, MAX_FRAMES_TO_SEND).map(function(n) {
            return n.toFixed(1);
        }).toString(), "".concat(result.startOfTracking), result.status, pageName, loadType, result.status);
        var loadTimeInteractions = getGlobalProperty("loadTimeInteractions");
        trackInfraUpltTimingTraceUserInteractions(JSON.stringify(loadTimeInteractions), "".concat(result.startOfTracking));
    }).finally(function() {
        var stopLoadTimeInteractionTracking = getGlobalProperty("stopLoadTimeInteractionTracking");
        if (stopLoadTimeInteractionTracking) {
            stopLoadTimeInteractionTracking();
        }
    });
};
